import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Award, Trophy, Star, Zap, Flame, Loader2 } from "lucide-react";

export const BADGE_STYLE = {
  team_win: { icon: Trophy, cls: "from-amber-400 to-orange-500" },
  perfect: { icon: Star, cls: "from-violet-500 to-fuchsia-500" },
  fastest: { icon: Zap, cls: "from-sky-400 to-blue-600" },
  streak: { icon: Flame, cls: "from-rose-500 to-red-600" },
};

const fmt = (d) => { try { return new Date(d).toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" }); } catch { return ""; } };

export function BadgeItem({ b }) {
  const st = BADGE_STYLE[b.kind] || { icon: Award, cls: "from-slate-400 to-slate-600" };
  return (
    <div className="flex gap-3 items-start bg-white rounded-2xl border border-nardo-200 p-3 shadow-sm" data-testid={`badge-${b.id}`}>
      <div className={`shrink-0 w-12 h-12 rounded-full bg-gradient-to-br ${st.cls} text-white flex items-center justify-center shadow-md ring-4 ring-white`}><st.icon className="w-6 h-6" /></div>
      <div className="min-w-0 flex-1">
        <div className="font-bold text-navy leading-tight">{b.title}</div>
        <div className="text-sm text-nardo-600">{b.detail}</div>
        <div className="text-[11px] text-nardo-500 mt-1">Concurso «{b.contest}»{b.subject ? ` · ${b.subject}` : ""}{b.teacher ? ` · Prof. ${b.teacher}` : ""} · {fmt(b.created_at)}</div>
      </div>
    </div>
  );
}

export default function StudentBadges({ token, compact = false }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/student/badges", { headers: { "X-Parent-Token": token } }).then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [token]);
  if (rows === null) return <Loader2 className="w-5 h-5 animate-spin text-navy" />;
  const count = (k) => rows.filter((r) => r.kind === k).length;
  return (
    <div className={compact ? "bg-white/70 backdrop-blur rounded-2xl border border-white/60 shadow-lg p-5 sm:p-6 mt-6" : ""} data-testid="student-badges">
      <div className="flex items-center gap-2 mb-4"><Award className="w-5 h-5 text-amber-500" /><h2 className="font-display font-bold text-lg text-navy">Medallas e insignias</h2>
        <span className="ml-auto text-xs font-semibold bg-amber-100 text-amber-800 px-2.5 py-1 rounded-full" data-testid="badges-total">{rows.length}</span></div>
      {!rows.length ? <div className="text-sm text-nardo-500 py-6 text-center" data-testid="badges-empty">Aún no hay medallas. ¡Se ganan participando en los concursos en vivo!</div> : (
        <>
          <div className="flex flex-wrap gap-2 mb-4">{Object.entries(BADGE_STYLE).map(([k, s]) => count(k) > 0 && (
            <span key={k} className={`inline-flex items-center gap-1 text-xs font-semibold text-white bg-gradient-to-r ${s.cls} px-2.5 py-1 rounded-full`}><s.icon className="w-3.5 h-3.5" /> ×{count(k)}</span>))}</div>
          <div className="grid sm:grid-cols-2 gap-2">{rows.map((b) => <BadgeItem key={b.id} b={b} />)}</div>
        </>
      )}
    </div>
  );
}
